const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

document.querySelectorAll('.honeycomb').forEach(honeycomb => {
    if (isSafari) {
        honeycomb.classList.add('safari');
    }
});
